import { isServerSide } from 'helpers/ssr';

// use only in client side
export const isSmallScreen = () => !isServerSide() && window.innerWidth < 768;
